import { postWithAuth, getWithAuth, putWithAuth } from "../../Basic/HttpService";

export const getAllInternalDash = async () => {
  let res = await getWithAuth(`InternalDashboard`);
  return res;
};
